





















































































import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({})
export default class Preguntas extends Vue {
  /* eslint-disable no-console */
  private preguntas: any = [];
  private preguntasAux = this.$store.getters.preguntas;
  private selected: any = []; // Variables checkboxes
  // SnackBar
  private snackbar = false;
  private text = '';
  private type = '';
  private timeout = 2000;
  // Dialog
  private dialogSuccess = false;
  private imgDialog = require('../assets/imagenes/success_dog.png');
  private textDialog = '';

  private redirect = 'https://www.petco.com.mx';

  private redirectTo() {
    if (this.$store.getters.nombreTienda.length > 0) { 
      this.redirect = "https://nps.petco.com.mx/tienda/"+this.$store.getters.idUser
    }
  }

  
  /* Métodos */
  private getValorPregunta() {
    let puntaje = this.$store.getters.puntaje;
    if (this.isDefined(puntaje)) {
      if (puntaje <= 6) {
        this.textDialog = 'Hemos recibido tu mensaje, lo enviaremos al responsable del área para trabajar en esta oportunidad para brindarte un mejor servicio'
      } 
    }
  }
  private isDefined(param: any) {
    return param !== null && param !== undefined && param !== '';
  }

  private created() {
    this.redirectTo()
    // Llenado de preguntas
    for (let i of this.preguntasAux.preguntas1) {
      if (i.NPS_PREGUNTA_TXT != null || i.NPS_PREGUNTA_TXT != '' || i.NPS_PREGUNTA_TXT.length !== 0) {
        this.preguntas.push({TITULO: i.NPS_PREGUNTA_TXT, ID: i.ID_NPS_PREGUNTA});
      }
    }  
    for (let i of this.preguntasAux.preguntas2) {
      if (i.NPS_PREGUNTA_TXT != null && i.NPS_PREGUNTA_TXT != '' && i.NPS_PREGUNTA_TXT.length !== 0) {
        this.preguntas.push({TITULO: i.NPS_PREGUNTA_TXT, ID: i.ID_NPS_PREGUNTA});
      }
    } 
    for (let i of this.preguntasAux.preguntas3) {
      if (i.NPS_PREGUNTA_TXT != null || i.NPS_PREGUNTA_TXT != '' || i.NPS_PREGUNTA_TXT.length !== 0) {
        this.preguntas.push({TITULO: i.NPS_PREGUNTA_TXT, ID: i.ID_NPS_PREGUNTA});
      }
    }
    this.getValorPregunta();
  }

  private createSnackBar (text: string, type: string) {
    this.snackbar = true;
    this.text = text;
    this.type = type;
  }

  private validateForm() {
    // Guardamos preguntas
    if (this.selected.length >  0) {
      let data = {
        idNPS: this.$store.getters.idComentarioInsertado,
        preguntas: this.selected
      }
      this.$store.dispatch('GuardaPreguntas', {data: data})
      .then ((respuesta) => {
        if (respuesta) {
          this.dialogSuccess = true;
          this.$store.dispatch('LimpiaState'); // Limpieza de store.
          setTimeout(() => {
            window.location.href = this.redirect;
          }, 4500);
        }
      })  
      .catch ((error) => {
        this.createSnackBar('Error al enviar datos, intenta más tarde', 'error');
      });
    } else {
      this.createSnackBar('Selecciona al menos un problema', 'error');
    }
    
  }
}
